import React, { useEffect, useRef } from "react";
import { Background, NavBar } from "../../Components";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { INVITE_EXPIRED_PAGE_CONTENT } from "../../utils/constants";
import "./InviteExpiredPage.scss"

function InviteExpiredPage() {
  const location = useLocation();
  return (
    <>
      <Background>
        <Box className="success-page-body">
          <Box className="success-page-header" >
            <label> {INVITE_EXPIRED_PAGE_CONTENT.header} </label>
            <Box className="circular-icon" > {INVITE_EXPIRED_PAGE_CONTENT.icon} </Box>
          </Box>
          <Box className="invite-expired-msg">
            {location.state.errorMessage}
          </Box>
        </Box>
      </Background>
    </>
  );
}

export default InviteExpiredPage;
